var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropdownCopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-310 -697) translate(301 688) translate(9 9) translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5385FB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.625 6.25L9.375 12.656 15.348 18.75",
    transform: "rotate(-90 12.5 12.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.5,
    stroke: "#5385FB",
    strokeWidth: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropdownCopy2);
export default __webpack_public_path__ + "static/media/arrow_dropdown_copy_2.4986d3696325e994ea68c2e25dae0279.svg";
export { ForwardRef as ReactComponent };